import { Module } from "../lib/modules";
import { StateManager } from "../lib/stateManager";

interface CookieState {}

export const CookieConsent: Module<CookieState> = () => {
  const state = new StateManager<CookieState>({});

  // Flag to determine if we should reload the page on decline
  let reloadOnDecline = false;

  const init = () => {
    attachEventListeners();
    initCookieConsent();
  };

  const attachEventListeners = () => {
    const cookieButton = document.getElementById("redo-cookie-consent");
    if (cookieButton) {
      cookieButton.addEventListener("click", (e) => {
        e.preventDefault();
        reloadOnDecline = true;
        localStorage.removeItem("cookie_consent");
        localStorage.removeItem("analytics_consent");
        initCookieConsent();
      });
    } else {
      console.warn("Cookie consent button not found in the DOM.");
    }
  };
  const detachEventListeners = () => {};
  const destroy = () => {
    detachEventListeners();
  };

  const initCookieConsent = () => {
    const consentKey = "cookie_consent";
    const analyticsKey = "analytics_consent";
    const consentBanner = document.getElementById("cookie-consent");
    const acceptButton = document.getElementById("cookie-accept");
    const declineButton = document.getElementById("cookie-decline");

    if (!consentBanner || !acceptButton || !declineButton) {
      console.error("Cookie consent elements not found in the DOM.");
      return;
    }

    // Check if user has already made a choice
    const existingConsent = localStorage.getItem(consentKey);

    if (existingConsent === null) {
      // Show banner if no choice has been made
      consentBanner.style.display = "block";
    } else if (existingConsent === "accepted") {
      // Load analytics if previously accepted
      loadAnalytics();
    }

    // Handle accept button
    acceptButton.addEventListener("click", () => {
      localStorage.setItem(consentKey, "accepted");
      localStorage.setItem(analyticsKey, "true");
      consentBanner.style.display = "none";
      loadAnalytics();
    });

    // Handle decline button
    declineButton.addEventListener("click", () => {
      // Set new values
      localStorage.setItem(consentKey, "declined");
      localStorage.setItem(analyticsKey, "false");

      // If previously accepted, reload the page to reset analytics
      if (reloadOnDecline) {
        window.location.reload();
      }

      consentBanner.style.display = "none";
      // Don't load analytics
    });
  };

  const loadAnalytics = () => {
    // Check if analytics function exists and call it
    if (typeof (window as any).loadAnalytics === "function") {
      (window as any).loadAnalytics();
    }
  };

  return {
    init,
    attachEventListeners,
    detachEventListeners,
    destroy,
    state: state,
    pageBlacklist: ["/admin/*"],
    name: "cookieConsent"
  };
};
